import {
  Tooltip,
} from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import {
  Star,
  StarBorder,
  StarHalf,
 } from "@mui/icons-material";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
  })
);
export default function StarRate(props:{
    fontSize?: "inherit" | "medium" | "large" | "small" | undefined
    max:number,
    value:number
  }) {
  const classes = useStyles();
  const value = Math.round(props.value*2)/2;
  const max = Math.floor(props.max);
  const fontSize: "inherit" | "medium" | "large" | "small" | undefined = props.fontSize;
  return (
      <div className={classes.root}>
        {[...Array(+max).keys()].map(i => {
          let icon = <Star fontSize={fontSize} />
          if(i+1 <= value){
            icon = <Star fontSize={fontSize} />
          } else if(i+.5 === value){
            icon = <StarHalf fontSize={fontSize} />
          } else {
            icon = <StarBorder fontSize={fontSize} />
          }
          return (<Tooltip title = {value} key={`tt${i+1}`} ><span className="star" key={`ss${i+1}`} data-value={i+1}>{icon}</span></Tooltip>)
        })
        }
      </div>
  );
}